import React, { Component } from 'react';

class Formatter extends Component {
  render() {
    const { array, field, value } = this.props;
    let input;
    if (typeof value === 'string') {
      input = array.find((x) =>
        typeof x[field] != 'string'
          ? x[field] == value
          : x[field]
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
              .trim() ==
            value
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
              .trim()
      );
    } else {
      input = array.find((x) => x[field] == value);
    }

    if (!input) {
      return null;
    }

    return (
      <span>
        {input.icon && <i className={`${input.icon} ${input.iconCss || ''} mr-1`} />}
        {input.label}
      </span>
    );
  }
}

export default Formatter;
